import { QUESTION_TYPES, SURVEY_BUILDER_POPUP_TYPES } from '../constants';

export const getNumberOfQuestionsToCharge = surveyLists => {
  const processedSurveyLists =
    surveyLists &&
    surveyLists.filter(
      q =>
        q.type !== QUESTION_TYPES.DISTRIBUTOR &&
        (!q.profiling || !q.profiling.isProfilingQuestion) &&
        q.type !== QUESTION_TYPES.MATRIX
    );
  const lengthOfInitialProcessedSurveyLists = processedSurveyLists.length;

  const matrixQuestions =
    surveyLists && surveyLists.filter(q => q.type === QUESTION_TYPES.MATRIX);
  const matchingMatrixRows = matrixQuestions.reduce((acc, q) => {
    const matrixRows =
      q.choices &&
      q.choices.filter(
        c =>
          q.matrix && q.matrix.decisionFrameworkType === c.decisionFrameworkType
      );
    return acc + (matrixRows ? matrixRows.length : 0);
  }, 0);

  return lengthOfInitialProcessedSurveyLists + 2 * (matchingMatrixRows || 0);
};

export const getChargeAmount = (
  numberOfSurveyQuestions,
  questionsIncludedInLicence
) => {
  const baseCharge = numberOfSurveyQuestions <= 5 ? 1 : 2.5;
  const numberOfBatchesWithFiveAboveLicence =
    numberOfSurveyQuestions - questionsIncludedInLicence;

  let additionalCredits = 0;
  if (numberOfBatchesWithFiveAboveLicence > 0) {
    const numberOfBatches = Math.ceil(numberOfBatchesWithFiveAboveLicence / 5);

    let internalQuestionsCounter = questionsIncludedInLicence;
    let leftToInclude = numberOfBatchesWithFiveAboveLicence;
    if (numberOfBatches) {
      Array.from(Array(numberOfBatches).keys()).forEach(() => {
        let stepIncrement = 5;

        if (leftToInclude < 5) {
          stepIncrement = leftToInclude;
        }

        leftToInclude -= stepIncrement;
        internalQuestionsCounter += stepIncrement;

        if (internalQuestionsCounter > 25) {
          additionalCredits += 2;
        } else {
          additionalCredits += 1.5;
        }
      });
    }
  }

  return baseCharge + additionalCredits;
};

export default (
  isAdmin,
  survey,
  surveyLists,
  accountManagement,
  surveyPermissionsCharge
) => {
  const numberOfQuestionsToCharge = getNumberOfQuestionsToCharge(surveyLists);
  const chargeAmount = getChargeAmount(
    numberOfQuestionsToCharge,
    accountManagement.permissions.questionsPerSurveyIncludedInLicence
  );

  const isChargeAmountIncreased =
    (surveyPermissionsCharge &&
      surveyPermissionsCharge.chargeAmount === null &&
      chargeAmount > 2.5) ||
    (surveyPermissionsCharge &&
      surveyPermissionsCharge.chargeAmount &&
      chargeAmount > 2.5 &&
      chargeAmount > surveyPermissionsCharge.chargeAmount);

  if (survey) {
    if (!survey.paid) {
      const parentRecords = [
        ...accountManagement.manager,
        ...accountManagement.parents
      ];
      const isThereAnyLicence = parentRecords.some(
        pR => pR.creditsLeft !== null
      );
      if (
        !isThereAnyLicence &&
        !surveyPermissionsCharge.noLicenceMoreThan15WarningShown &&
        numberOfQuestionsToCharge > 15
      ) {
        return {
          accountManagementWarning:
            SURVEY_BUILDER_POPUP_TYPES.NO_LICENCE_MORE_THAN_15,
          chargeAmount
        };
      }

      if (isChargeAmountIncreased) {
        return {
          accountManagementWarning:
            SURVEY_BUILDER_POPUP_TYPES.EXTRA_QUESTIONS_ABOVE_LICENCE_ADDED,
          chargeAmount
        };
      }
    }

    if (survey.paid && !surveyPermissionsCharge.unpublishedWarningShown) {
      return {
        accountManagementWarning:
          SURVEY_BUILDER_POPUP_TYPES.SURVEY_UNPUBLISHED_QUESTIONS_ADDED,
        chargeAmount
      };
    }
  }

  return {
    accountManagementWarning: null,
    chargeAmount
  };
};
